import {createBrowserHistory} from 'history';
import base from "./u_Base";

export default createBrowserHistory({
    basename:base.BASENAME
});
